import { useSyncExternalStore } from 'react';

/** Reactive media query (layout switches between phone and laptop views). */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(query);
      m.addEventListener('change', cb);
      return () => m.removeEventListener('change', cb);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Re-render every `ms` so ages ("2h 05m") and the clock stay current. */
export function useTick(ms = 30_000): number {
  return useSyncExternalStore(
    (cb) => {
      const id = setInterval(cb, ms);
      return () => clearInterval(id);
    },
    () => Math.floor(Date.now() / ms),
    () => 0,
  );
}
